export default () => ({
    isOpen: false,

    init() {
        this.$el.addEventListener(
            'toggle',
            (event) => (this.isOpen = event.newState === 'open')
        )

        if (this.$el.id && this.$el.id === window.location.hash.substring(1)) {
            this.$el.open = true
        }
    },
})
